module.exports = __webpack_public_path__ + "img/2.72c1afbf.jpg";